export default __webpack_public_path__ + "static/media/excelstep2.bee94632.png";